import React from 'react';
import { Link } from 'react-router-dom';
export function EvaSchiffererFooter() {
  return <footer id="kontakt" className="w-full py-12 px-6 md:px-12 bg-gray-100" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <div className="p-6 rounded-lg flex flex-col md:flex-row gap-6" data-id="element-97">
          <div className="flex-shrink-0" data-id="element-98">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vCRzYvr5gU9tD4wLqujbVq/Eva_Schifferer-v4.jpg" alt="Eva Sophie Schifferer" className="rounded-lg shadow-md h-64 w-auto object-cover" data-id="element-99" />
          </div>
          <div className="flex-grow flex flex-col" data-id="element-100">
            <h3 className="text-xl font-medium text-gray-700 mb-3" data-id="element-101">Kontakt</h3>
            <p className="text-gray-600 mb-2 leading-tight" data-id="element-102">
              Eva Sophie Schifferer
            </p>
            <p className="text-gray-600 mb-1" data-id="element-103">Rohrbachstraße 35</p>
            <p className="text-gray-600 mb-2" data-id="element-104">60389 Frankfurt</p>
            <p className="text-gray-600 mb-4 leading-tight" data-id="element-105">
              E-Mail:{' '}
              <a href="mailto:praxis@evaschifferer.com" className="hover:text-[#c2cde0] hover:font-semibold transition-colors" data-id="element-106">
                praxis@evaschifferer.com
              </a>
            </p>
            <p className="text-gray-600 mb-4 leading-tight" data-id="element-107">
              Lassen Sie uns sprechen – ich freue mich auf Sie!
            </p>
            <Link to="/eva_schifferer/termin-vereinbaren" className="block w-full mt-auto" data-id="element-108">
              <button className="w-full py-3 px-6 bg-blue-100 text-gray-700 rounded-md hover:bg-[#c2cde0] hover:font-semibold transition-colors" data-id="element-109">
                Termin vereinbaren
              </button>
            </Link>
          </div>
        </div>
        <div className="mt-6 text-center" data-id="element-110">
          <p className="text-gray-600 mb-4" data-id="element-111">Mitglied im BDP und VFP</p>
          <div className="flex justify-center items-center gap-6" data-id="element-112">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qLsdcVbuKGuWHzZUxcUycV/Eva_Schifferer-Mitglied_im_BDP.png" alt="BDP Mitglied" className="h-20 w-auto" data-id="element-113" />
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4Na4L5qBM9grHK2TKKJJDn/Eva_Schifferer-Mitglied_im_VFP.png" alt="VFP Mitglied" className="h-20 w-auto" data-id="element-114" />
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-gray-200" data-id="element-115">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-116">
          <div className="mb-4 md:mb-0" data-id="element-117">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sBeLHqEvA69hG4RGUSQpxM/Logo-Schifferer_Sturny-final2.png" alt="Praxis für Beratung und Psychotherapie Logo" className="h-12" data-id="element-118" />
          </div>
          <div className="flex flex-col md:flex-row items-center text-gray-500 text-sm" data-id="element-119">
            <div className="flex space-x-4 mb-2 md:mb-0 md:mr-4" data-id="element-120">
              <Link to="/datenschutz" className="hover:text-[#c2cde0] transition-colors" data-id="element-121">
                Datenschutz
              </Link>
              <Link to="/impressum" className="hover:text-[#c2cde0] transition-colors" data-id="element-122">
                Impressum
              </Link>
            </div>
            <div data-id="element-123">
              © {new Date().getFullYear()} Praxis für Beratung und
              Psychotherapie. Alle Rechte vorbehalten.
            </div>
          </div>
        </div>
      </div>
    </footer>;
}